import { FunctionComponent } from 'react';
import Loader from './Loader';

interface LoaderMaskProps {
    title?: string;
    subtitle?: string;
    type?: '' | 'absolute' | 'relative' | 'fixed';
    children?: React.ReactNode;
}

const LoaderMask: FunctionComponent<LoaderMaskProps> = ({ title = '', subtitle = '', type = '', children }: LoaderMaskProps) => {

    let loaderType = '';

    switch (type) {
        case 'absolute':
            loaderType = 'loader-mask--absolute';
            break;
        case 'relative':
            loaderType = 'loader-mask--relative';
            break;
        case 'fixed':
            loaderType = 'loader-mask--fixed';
            break;
        default:
            loaderType = '';
    }

    return (
        <div className={`loader-mask ${loaderType}`}>
            {
                title &&
                <div className="loader-mask__title">
                    {title}
                </div>
            }
            {
                children
            }
            {
                !children &&
                <Loader size="small" />
            }
            {
                subtitle &&
                <div className="loader-mask__subtitle">
                    {subtitle}
                </div>
            }
        </div>
    );
};

export default LoaderMask;